(() => {
  'use strict';
  angular
    .module('uwAgenda.global')
    .factory('IntegrationService', ['$http', IntegrationServiceFn]);

  function IntegrationServiceFn($http) {
    const baseUrl = '/api/integrations';

    return {
      activateIntegration,
      updateIntegrationKey,
      updateAutoDeactivateContacts,
      deactivateIntegration,
      getIntegrationsByUserId,
      getIntegrationsById,
      getIntegrationsSharedWithUser
    };

    function activateIntegration(ownerId, type, autoDeactivateContacts) {
      return $http.post(baseUrl, {ownerId, type, autoDeactivateContacts}).then(response => response.data);
    }

    function updateIntegrationKey(id) {
      return $http.patch(`${baseUrl}/${id}/key`).then(response => response.data);
    }
    function updateAutoDeactivateContacts(id, autoDeactivateContacts) {
      return $http.patch(`${baseUrl}/${id}/autoDeactivateContacts`, { autoDeactivateContacts })
          .then(response => response.data);
    }

    function deactivateIntegration(id) {
      return $http.delete(`${baseUrl}/${id}`).then(response => response.data);
    }

    function getIntegrationsByUserId(ownerId) {
      return $http.get(`${baseUrl}?ownerId=${ownerId}`).then(response => response.data);
    }

    function getIntegrationsSharedWithUser(ownerId) {
      return $http.get(`${baseUrl}?sharedWithOwnerId=${ownerId}`).then(response => response.data);
    }

    function getIntegrationsById(id) {
      return $http.get(`${baseUrl}/${id}`).then(response => response.data);
    }
  }
})();